import { AddCandidate } from "../../../../models/addCandidate";
class AddCandidatesController {
    /*@ngInject*/
    constructor($rootScope, StorageService, candidateService, jobService, companyService, modalService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.StorageService = StorageService;
        this.candidateService = candidateService;
        this.jobService = jobService;
        this.companyService = companyService;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        // variables
        this.currentCompanyId = this.$rootScope.userDetails.company.companyId;
        this.userId = this.$rootScope.userDetails.id;
        // flags
        this.loadingResumeOptions = true;
        this.showResumeOptions = false;
        this.isAddCandidateForCorp = false;
        this.candidatesArray = [];
        this.savingFlag = false;
        this.controlObject = {};
        this.controlObject.disableCancelButtonFlag = false;
        this.addWithResumesFlag = true;
        this.sendOutreachEmail = false;
        this.isOutreachEnabled = false;
        this.isAddCandidateForCorp = this.companyService.isCorporateCompany() || (!_.isUndefined(this.corporateId) && this.corporateId !== "");
        this._setResumeOptions();
        this._checkIfOutreachEnabled();
    }
    _setResumeOptions() {
        let companyIdToCheckAUploadResumeAccess;
        // include clientOrBuId only for staffing company client
        if (this.isAddCandidateForCorp || (this.jobId == undefined || _.isNull(this.jobId) || this.jobId == "")) {
            this.clientOrBuId = null;
        }
        if (!_.isUndefined(this.corporateId) && this.corporateId !== "") {
            companyIdToCheckAUploadResumeAccess = this.corporateId;
        }
        else {
            companyIdToCheckAUploadResumeAccess = this.currentCompanyId;
        }
        //Check for resume options only for external reqs and shared reqs
        if (this.onlyUploadResume) {
            this.showResumeOptions = false;
            this.loadingResumeOptions = false;
        }
        else if ((this.isSharedJob && !_.isUndefined(this.corporateId) && this.corporateId !== "") || (!this.isAddCandidateForCorp)) {
            this.companyService.hasAccessToUploadResume(companyIdToCheckAUploadResumeAccess, this.clientOrBuId, (data) => {
                this.showResumeOptions = !data;
                this.addAnotherCandidate();
                if (this.showResumeOptions) {
                    this._setDefaultCandidateAddOption();
                }
                else {
                    this.loadingResumeOptions = false;
                }
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.addAnotherCandidate();
            this.showResumeOptions = true;
            this._setDefaultCandidateAddOption();
        }
    }
    _checkIfOutreachEnabled() {
        // this.candidateService.getOutreachEmailEnabledStatus((data) => {
        //     this.isOutreachEnabled = data;
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        this.isOutreachEnabled = true;
    }
    _setDefaultCandidateAddOption() {
        if (this._isAddCandidateToJob()) {
            this.jobService.getLastCandidateAddOption(this.jobId, (data) => {
                if (data["lastAddCandidateOption"] == "Without Resume") {
                    this.addWithResumesFlag = false;
                }
                else {
                    this.addWithResumesFlag = true;
                }
                this.loadingResumeOptions = false;
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.loadingResumeOptions = false;
        }
    }
    _isAddCandidateToJob() {
        return this.jobId !== undefined;
    }
    onAddCandidateOptionChange() {
        this.StorageService.set('addCandidateWithResumeEnabled', this.addWithResumesFlag);
    }
    addAnotherCandidate() {
        let addCandidate = new AddCandidate();
        addCandidate.jobId = this.jobId;
        addCandidate.companyId = this.currentCompanyId;
        addCandidate.addStatus = 'add';
        addCandidate.errorMessages = [];
        this.candidatesArray.push(addCandidate);
    }
    removeCandidate(index) {
        this.candidatesArray.splice(index, 1);
    }
    cancel() {
        if (this.addWithResumesFlag) {
            this.$rootScope.$broadcast('cancelUploadResume', null);
            if (this.context === 'candidateScreen') {
                if (this.saveCallback) {
                    this.saveCallback();
                }
            }
        }
        else {
            // add without resume
            let unsavedCandidatesExistFlag = false;
            angular.forEach(this.candidatesArray, (val, key) => {
                if (val.addStatus != 'success') {
                    unsavedCandidatesExistFlag = true;
                }
            });
            if (unsavedCandidatesExistFlag && this.candidatesArray.length == 1) {
                // if only one candidate is there, check to ensure that it is not the default record that is shown.
                if (_.isUndefined(this.candidatesArray[0].firstName) && _.isUndefined(this.candidatesArray[0].lastName) && _.isUndefined(this.candidatesArray[0].emailId) && _.isUndefined(this.candidatesArray[0].phoneNumber)) {
                    // if it is the default candidate and all values are empty
                    unsavedCandidatesExistFlag = false;
                }
            }
            if (unsavedCandidatesExistFlag) {
                bootbox.confirm({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                    message: "Are you sure you want to cancel ?<br> Unsaved data will be lost.",
                    className: "zIndex1060",
                    backdrop: true,
                    onEscape: false,
                    buttons: {
                        confirm: {
                            label: 'Yes',
                            className: 'btn-info'
                        },
                        cancel: {
                            label: 'Cancel',
                            className: 'btn-danger'
                        }
                    },
                    callback: (result) => {
                        if (result) {
                            if (this.saveCallback) {
                                this.saveCallback();
                            }
                        }
                        else {
                            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                        }
                    }
                });
            }
            else {
                if (this.saveCallback) {
                    this.saveCallback();
                }
            }
        }
    }
    saveCandidates() {
        let candidatesArrayForSave = [];
        let candidateAddUIErrorExists = false;
        angular.forEach(this.candidatesArray, (val, key) => {
            if (val.addStatus != 'success') {
                candidatesArrayForSave.push(angular.copy(val));
                val.addForm.$submitted = true;
                if (val.addForm.$invalid) {
                    candidateAddUIErrorExists = true;
                }
            }
        });
        if (!candidateAddUIErrorExists) {
            let actualCandidatesArrayForSave = candidatesArrayForSave.map((y, index) => {
                delete y.addForm;
                delete y.addStatus;
                delete y.errorMessages;
                return y;
            });
            if (actualCandidatesArrayForSave.length > 0) {
                this.savingFlag = true;
                this.candidateService.addCandidates(actualCandidatesArrayForSave, (data) => {
                    let allCandidatesAddedFlag = true;
                    let responseArrayIndexCounter = 0;
                    // iterate over candidates array and look for candidates whose current addStatus is not already 'success'
                    angular.forEach(this.candidatesArray, (val, key) => {
                        // if status is not already a success, we have a candidate who was added in the current request
                        if (val.addStatus != 'success') {
                            if (data[responseArrayIndexCounter].status == 'PASSED') {
                                val.addStatus = 'success';
                            }
                            else {
                                allCandidatesAddedFlag = false;
                                val.addStatus = 'error';
                                val.errorMessages = data[responseArrayIndexCounter].messages;
                            }
                            // increment the responseArrayIndexCounter to be able to access the next candidate in the response
                            responseArrayIndexCounter++;
                        }
                    });
                    if (this.sendOutreachEmail && allCandidatesAddedFlag) {
                        let passedCandidateList = [];
                        if (data.length > 0) {
                            data.map(candidate => {
                                if (candidate.status === 'PASSED') {
                                    passedCandidateList.push({ id: candidate.candidateDetailDto.id, candidateType: "OWN_CANDIDATES" });
                                }
                            });
                        }
                        let outreachObject = {
                            candidates: passedCandidateList,
                            userId: this.userId,
                            companyId: this.currentCompanyId,
                            clientOrBuId: this.clientOrBuId
                        };
                        if (outreachObject.candidates.length > 0) {
                            this.candidateService.sendOutreachEmail(outreachObject, (data) => {
                                this.savingFlag = false;
                                this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                                this.alertsAndNotificationsService.showAlertWithCallBack("Success!", "All candidates have been added successfully!", "success", () => {
                                    if (this.saveCallback) {
                                        this.saveCallback();
                                    }
                                });
                            }, (error) => {
                                this.savingFlag = false;
                                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            });
                        }
                        else {
                            this.savingFlag = false;
                        }
                    }
                    else {
                        this.savingFlag = false;
                        if (allCandidatesAddedFlag) {
                            this.alertsAndNotificationsService.showAlertWithCallBack("Success!", "All candidates have been added successfully!", "success", () => {
                                if (this.saveCallback) {
                                    this.saveCallback();
                                }
                            });
                        }
                    }
                }, (error) => {
                    this.savingFlag = false;
                    if (this.$rootScope.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }
        }
    }
    onCandidateProcessed() {
        if (this.candidateProcessedCallback) {
            this.candidateProcessedCallback();
        }
    }
}
AddCandidatesController.$inject = ['$rootScope', 'StorageService', 'candidateService', 'jobService', 'companyService', 'modalService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './add-candidates.html';
import * as TEMPLATE from 'raw-loader!./add-candidates.html';
export const AddCandidatesComponent = {
    bindings: {
        jobId: '@',
        isSharedJob: '<',
        onlyUploadResume: '<',
        singleUploadResume: '<',
        candidateId: '@',
        corporateId: '@',
        clientOrBuId: '@',
        saveCallback: '&',
        candidateProcessedCallback: '&',
        context: '@',
        sourceScreen: '@',
        formalizeActivityPayload: '<'
    },
    controller: AddCandidatesController,
    template: TEMPLATE.default
    // templateUrl: 'app/partials/missioncontrol/addCandidates/addCandidates/add-candidates.html'
};
//# sourceMappingURL=add-candidates.component.js.map